import { SERVER_MERCHANT_LIST_GET_SUCCESS, SERVER_MERCHANT_LIST_GET_FAILURE } from '../actions/types';

const initialState = {
  html: null,
  isLoading: false,
  isLoaded: false,
};

/**
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
const merchantsList = (state = initialState, action) => {
  switch (action.type) {
    case SERVER_MERCHANT_LIST_GET_SUCCESS: {
      const html = action.response;

      return {
        ...state,
        html,
        isLoading: false,
        isLoaded: true,
      };
    }
    case SERVER_MERCHANT_LIST_GET_FAILURE: {
      return {
        ...state,
        html: null,
        isLoading: false,
        isLoaded: true,
      }; // we'd have to decide what to do with error state
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === SERVER_MERCHANT_LIST_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};

export default merchantsList;
